import React, { ReactNode, useContext } from 'react';
import { Stack } from 'office-ui-fabric-react';

import { mapContext } from '../mapContext';

import { RouteProps } from './DetailsInfo.types';
import { Styled } from './DetailsInfo.styles';
import { typeSafeObjectKeys } from './typings';
import { routeStrings } from './consts';
import { IParsedStop } from '../../../Video/OnlineWatching/utils/parseRoutes';
import { useMapHelpers } from '../../../../../hooks/useMapHelpers';

export const RouteDetails: React.FC<RouteProps> = ({ id }) => {
  const { routes, mapElements, mapRef, setDetailsInfo } = useContext(
    mapContext
  );
  const { centerMap } = useMapHelpers(mapRef);

  const route = routes.find((route) => route.id === id);

  if (!route) return null;

  const relativeStops = mapElements?.selectedStops.reduce<IParsedStop[]>(
    (res, cur) => {
      if (cur.route_id === route.id && !res.find((s) => s.id === cur.id)) {
        return [...res, cur];
      }
      return res;
    },
    []
  );

  return (
    <Stack tokens={{ childrenGap: 16 }}>
      {typeSafeObjectKeys(routeStrings).map((key) => {
        let data: ReactNode = null;
        switch (key) {
          case 'name':
          case 'short_name':
            data = route[key];
            break;
          case 'stops':
            data = (
              <Styled.ListWrapper>
                {relativeStops?.map(({ name, id, position }) => {
                  const onSelectStop = () => {
                    centerMap([position.lat, position.lng]);
                    setDetailsInfo(null);
                  };
                  return (
                    <button onClick={onSelectStop} key={id}>
                      {name}
                    </button>
                  );
                })}
              </Styled.ListWrapper>
            );
            break;
        }

        return (
          <Styled.InfoRow key={key}>
            <Styled.InfoRowTitle>{routeStrings[key]}</Styled.InfoRowTitle>
            <Styled.InfoRowData>{data || ' - '}</Styled.InfoRowData>
          </Styled.InfoRow>
        );
      })}
    </Stack>
  );
};
